import styled from 'styled-components';
import { useState } from 'react';
import { ReviewDesc } from '../components/ReviewList';
function Review() {
  const [reviewMore, setReviewMore] = useState(false);
  const handleToggleReviewBtn = () => {
    setReviewMore(!reviewMore);
  };
  return (
    <Wrap>
      <Title>REVIEW</Title>
      <br />
      <ListWrap reviewMore={reviewMore}>
        {ReviewDesc.map((item, i) => {
          return (
            <li key={i}>
              <img src="images/review_stars.png" />
              <p>
                {item.text.length > 140
                  ? `${item.text.slice(0, 140)}...`
                  : item.text}
              </p>
              <span>{item.id}</span>
            </li>
          );
        })}
        {reviewMore ? (
          <h1>
            <a
              href="https://m.expert.naver.com/expert/profile/home?storeId=100001175"
              target="_blank"
              rel="noopener"
              title="NAVER Expert"
            >
              더 많은 후기를 보려면 클릭하세요.
            </a>
          </h1>
        ) : (
          <p></p>
        )}
      </ListWrap>

      <MoreBtn onClick={handleToggleReviewBtn} reviewMore={reviewMore}>
        더보기
      </MoreBtn>
    </Wrap>
  );
}

const MoreBtn = styled.button`
  color: #6a6b88;
  font-size: 16px;
  padding-right: 30px;
  position: relative;
  margin-top: 30px;
  &:hover {
    font-weight: bold;
  }
  ::after {
    right: 0px;
    top: 0;
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    content: '';
    background: url('images/arrow.png') no-repeat;
    background-size: 100%;
    transform: rotate(-180deg);
  }
  ${({ reviewMore }) => {
    if (reviewMore) {
      return `margin-top: 50px; ::after {
        transform: rotate(0deg);
      }`;
    }
  }}
`;
const ListWrap = styled.ul`
  text-align: initial;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  padding: 0 10px;
  position: relative;
  height: 100%;
  ${({ reviewMore }) => {
    if (!reviewMore) {
      return `height:500px; overflow:hidden;`;
    }
  }}
  > p {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(255, 255, 255, 0.7));
    @media only screen and (max-width: 740px) {
      background: initial;
    }
  }
  > h1 {
    display: block;
    width: 100%;
    padding-right: 5%;
    text-align: right;
    @media only screen and (max-width: 992px) {
      padding-right: 0px;
      text-align: center;
    }
    > a {
      color: #2a4eb5;
      font-weight: bold;
    }
  }

  > li {
    padding: 15px;
    border-radius: 8px;
    box-shadow: 5px 5px 5px rgba(132, 139, 232, 0.2);
    width: 45%;
    position: relative;
    margin-bottom: 30px;
    @media only screen and (max-width: 750px) {
      width: 80%;
    }
    > img {
      width: 80px;
    }
    > p {
      color: #6a6b88;
      margin: 10px 0 30px;
      font-size: 14px;
    }
    > span {
      color: #4e5663;
      position: absolute;
      bottom: 15px;
      left: 15px;
    }
  }
`;
const Title = styled.h1`
  color: ${props => props.theme.mainColor};
  font-size: 25px;
  position: relative;
  display: inline-block;
  margin: 70px 0;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
  }
`;
const Wrap = styled.div`
  padding: 40px 0;
  text-align: center;
`;
export default Review;
